// Retrieves a color by its ID from a provided array of colors.
export const getColorById = (id, colors) => {
  if (colors && colors.length > 0) {
    let color = colors.filter((item) => item.id === id)[0];
    return color ? color : null;
  }
};
